module.exports = __webpack_public_path__ + "static/media/aauxnext-smit.749abbab.woff2";